import { render, staticRenderFns } from "./assetfrm.vue?vue&type=template&id=1362a32a"
import script from "./assetfrm.vue?vue&type=script&lang=js"
export * from "./assetfrm.vue?vue&type=script&lang=js"
import style0 from "./assetfrm.vue?vue&type=style&index=0&id=1362a32a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports